import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi'
import { refreshAlerts, setAlertsWallet } from './alertsStore'
import { PWA_SHEET_EVENT, PwaSheet } from './events'
import './installPrompt' // attaches the beforeinstallprompt listener with the app bundle
import { useServiceWorker } from './swRegister'

const InstallSheet = dynamic(() => import('./InstallSheet'), { ssr: false })

/**
 * Installable app + alerts (Bez, 2026-10-07): registers the service worker, keeps the alerts switch in step with the connected wallet
 * and the real subscription (read on load and whenever the tab comes back: the permission may have changed in the settings), and
 * opens the two sheets on request.
 */
export default function PwaLayer() {
  const [sheet, setSheet] = useState<PwaSheet | null>(null)
  const { address } = useAccount()
  useServiceWorker()
  useEffect(() => {
    setAlertsWallet(address)
  }, [address])
  useEffect(() => {
    refreshAlerts()
    const onVisible = () => {
      if (document.visibilityState === 'visible') refreshAlerts()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
  }, [])
  useEffect(() => {
    const on = (e: Event) => setSheet((e as CustomEvent<PwaSheet>).detail)
    window.addEventListener(PWA_SHEET_EVENT, on)
    return () => window.removeEventListener(PWA_SHEET_EVENT, on)
  }, [])
  if (sheet === 'install') return <InstallSheet onDismiss={() => setSheet(null)} />
  return null
}
